import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Fab, Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import { ReduxStore } from '../../../stores';
import MuiTheme from '../../../MuiTheme';
import { Section } from '../../../Models/Sections/@types';
import Form from '../../../Models/Sections/Form';
import { OSection } from '../../../Models/Sections/Model';
import SimpleCard from '../../../Components/SimpleCard';
import ConfirmationDialog from '../../../Components/ConfirmationDialog';
import { withRouter, RouteComponentProps } from 'react-router';
import { AxiosPromise } from 'axios';
import CircularLoader from '../../../Components/Loader/CircularLoader';
import { TDispatch } from '../../../Resources/GarbageUtils';

interface IStateProps {
    mainList: Array<Section>
}

interface IDispatchProps {
    getItemsList: (params?: any) => AxiosPromise
    deleteSection: (sectionId: string) => AxiosPromise
    togglePublish: (section: Section) => AxiosPromise
}

interface IState {
    showForm: boolean
    itemToEdit?: Section
    showConfrimationDialog: boolean
    itemToDelete?: Section
    loading: boolean
}

interface OwnProps { }

interface IProps extends WithStyles<typeof STYLES>, IStateProps, IDispatchProps, RouteComponentProps<{ chapterId: string }>, OwnProps { }

class Sections extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: false,
            showConfrimationDialog: false,
            loading: false
        }
    }

    togglePublishHandler = (section: Section) => this.props.togglePublish(section);

    OptionsConfig = [
        { icon: 'lock', label: 'Publish', handler: this.togglePublishHandler },
        { icon: 'edit', label: 'Edit', handler: (section: Section) => this.setState({ itemToEdit: section, showForm: true }) },
        { icon: 'delete', label: 'Delete', handler: (section: Section) => this.setState({ itemToDelete: section, showConfrimationDialog: true }) },
        // { icon: 'details', label: 'View Details', handler: (section: TSection) => this.setState({ selecteditem: section }) }
    ]

    async componentDidMount() {
        await this.setState({ loading: true });
        await this.props.getItemsList({ filter: { where: { chapterId: this.props.match.params['chapterId'] } } }).catch(error => { console.log('Error getting section data', error.response.data) });
        await this.setState({ loading: false });
    }

    handleDeleteItem = () => {
        if (this.state.itemToDelete) {
            this.props.deleteSection(this.state.itemToDelete.id);
            this.setState({ showConfrimationDialog: false });
        }
    }

    render() {
        const { classes, mainList = [], location } = this.props
        const { itemToEdit, itemToDelete, showForm, showConfrimationDialog, loading } = this.state;
        return (
            <div className={classes.root} >
                {
                    loading
                        ?
                        <CircularLoader />
                        :
                        <Grid container spacing={5} className={classes.listContainer} >
                            {
                                mainList.sort((a, b) => (a.number - b.number)).map((section, index) => {
                                    return (
                                        <Grid item sm={4} key={index} >
                                            <SimpleCard
                                                entity={section}
                                                title={`${section.number}. ${section.name || ''}`}
                                                optionsConfig={this.OptionsConfig}
                                                link={`${location.pathname}/${section.id}/exercises`}
                                            />
                                        </Grid>
                                    )
                                })
                            }
                        </Grid>
                }
                <Fab
                    color="secondary"
                    className={classes.addButton}
                    onClick={e => this.setState({ showForm: true })}
                >
                    <i className='material-icons' >add</i>
                </Fab>
                {showForm ? <Form section={itemToEdit} open={showForm} onClose={() => this.setState({ showForm: false, itemToEdit: undefined })} /> : null}
                <ConfirmationDialog
                    openState={showConfrimationDialog}
                    onAgree={this.handleDeleteItem}
                    onClose={() => this.setState({ showConfrimationDialog: false })}
                    title={itemToDelete ? itemToDelete.name || `${itemToDelete.number}. Section` : 'This Section'}
                    message={`Are you sure to delete ${itemToDelete ? itemToDelete.name || (itemToDelete.number + '. Section') : 'this section'}`}
                />
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({
    mainList: state.Sections.mainList
})

const mapDispatchToProps = (dispatch: TDispatch): IDispatchProps => ({
    getItemsList: (params?: any) => dispatch(OSection.getItemsList(params)),
    deleteSection: (sectionId: string) => dispatch(OSection.deleteItem(sectionId, {}, undefined, { deletedItemId: sectionId })),
    togglePublish: (section) => dispatch(OSection.postActivity(OSection.Activities.TOGGLE_PUBLISH, {}, { id: section.id, publish: !section.isPublished }))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        paddingTop: 25
    },
    addButton: {
        position: 'fixed',
        right: '24px', bottom: '24px'
    },
    listContainer: {
        width: '85%',
        marginTop: 36
    }
})

export default withRouter(connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Sections)))